import { render, staticRenderFns } from "./myinfo-row.vue?vue&type=template&id=1a8205d3"
import script from "./myinfo-row.vue?vue&type=script&lang=js"
export * from "./myinfo-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports